import { Style } from '@wix/thunderbolt-becky-types'

const SKIN_TO_PADDING_MAP = {
	IronPhoto: 12,
	ScotchTapePhoto: 10,
	SloppyPhoto: 9,
	VintagePhoto: 30,
}

const SKIN_TO_BOTTOM_PADDING_MAP = {
	NewPolaroidPhoto: 50,
	PolaroidPhoto: 30,
}

const SKIN_TO_BOX_STYLE = {
	CirclePhoto: [{ name: 'brw', val: 2 }],
	ClipArtSkin: [],
	DefaultPhoto: [],
	DoubleBorderCirclePhoto: [{ name: 'sz2', val: 6 }],
	DoubleBorderPhoto: [{ name: 'mrg1', val: 7 }],
	GlowLinePhoto: [],
	LiftedShadowPhoto: [{ name: 'brw', val: 2 }],
	LiftedTopPhoto: [{ name: 'brw', val: 2 }],
	MouseOverPhoto: [{ name: 'brw', val: 2 }],
	NewPolaroidPhoto: [{ name: 'brw', val: 2 }],
	NoSkinPhoto: [],
	PaperclipPhoto: [],
	PolaroidPhoto: [{ name: 'brw', val: 2 }],
	RoundPhoto: [{ name: 'brw', val: 2 }],
	RoundShadowPhoto: [{ name: 'brw', val: 2 }],
	ScotchDoubleHorizontal: [{ name: 'brw', val: 10 }],
	ScotchDoubleVertical: [{ name: 'brw', val: 10 }],
	ScotchTopPhoto: [{ name: 'brw', val: 10 }],
	VintagePhoto: [
		{ name: 'brw', val: 2 },
		{ name: 'pad', val: 15 },
	],
}

type SkinPaddingKey = keyof typeof SKIN_TO_PADDING_MAP
type SkinBottomPaddingKey = keyof typeof SKIN_TO_BOTTOM_PADDING_MAP
type SkinBoxStyleKey = keyof typeof SKIN_TO_BOX_STYLE

type StyleParam = {
	name: string
	val: number
}

function getBottomPadding(skin: SkinBottomPaddingKey) {
	return SKIN_TO_BOTTOM_PADDING_MAP[skin] || 0
}

function getFillersSumFromConsts(skin: string, extra: number) {
	const padding = (SKIN_TO_PADDING_MAP[skin as SkinPaddingKey] || 0) * 2

	return {
		width: padding + extra,
		height: padding + getBottomPadding(skin as SkinBottomPaddingKey) + extra,
	}
}

function getBoxSizeFromStyle(params: Array<StyleParam>, styleData: Style) {
	const styleProperties = styleData?.style?.properties || {}

	return params
		.map(
			(styleParam) =>
				(styleParam.name in styleProperties ? parseInt(styleProperties[styleParam.name], 10) : styleParam.val) *
				2
		)
		.reduce((acc, value: number) => {
			return acc + value
		}, 0)
}

// Legacy functionality - We calculate how much space is left for the image itself after what the border, padding, and margin take up
// This calculation depends on skin specific params
// If the result <=0 we will set min height/width to 16px
function getBoxParamsBySkin(skin: SkinBoxStyleKey): Array<StyleParam> {
	return SKIN_TO_BOX_STYLE[skin] || []
}

function getBoxDimensionsBySkin(skin: string, styleData: Style) {
	const extra = getBoxSizeFromStyle(getBoxParamsBySkin(skin as SkinBoxStyleKey), styleData)
	return getFillersSumFromConsts(skin, extra)
}

export { getBoxDimensionsBySkin }
